import { render, staticRenderFns } from "./WenziBianji.vue?vue&type=template&id=7229d496&"
import script from "./WenziBianji.vue?vue&type=script&lang=js&"
export * from "./WenziBianji.vue?vue&type=script&lang=js&"
import style0 from "./WenziBianji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports